import React from 'react';
import PropTypes from 'prop-types';
import { OlsConfigStore } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';

export const YotpoCSS = ({ products }) => {
  const { app_key: appKey } = OlsConfigStore.getState().yotpo_config || {};
  if (!appKey || !products || !products.length) {
    return null;
  }

  return (
    <style
      dangerouslySetInnerHTML={{
        __html: `
      .ratings-review-wrapper.product-list .yotpo-bottomline a {
        display: none;
      }
    `
      }}
    />
  );
};

YotpoCSS.propTypes = {
  products: PropTypes.array
};

export const hideEmptyStars = () => {
  const selector = '.ratings-review-wrapper.product-list .write-review-btn-hidden';
  document.querySelectorAll(selector).forEach(reviewElement => {
    // NEMO-8659: hide empty stars on Product List page
    reviewElement.parentNode.style.display = 'none';
  });
};
